module.exports = {
          srcSet: __webpack_public_path__ + "public/images/6a2ef29cd5d90d1bfbbd1501ba51995d-209.png"+" 209w",
          images:[ {path: __webpack_public_path__ + "public/images/6a2ef29cd5d90d1bfbbd1501ba51995d-209.png",width: 209,height: 59}],
          src: __webpack_public_path__ + "public/images/6a2ef29cd5d90d1bfbbd1501ba51995d-209.png",
          toString:function(){return __webpack_public_path__ + "public/images/6a2ef29cd5d90d1bfbbd1501ba51995d-209.png"},
          
          width: 209,
          height: 59
        }